import React, { Component } from 'react';
import {
  SafeAreaView,
  View,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Animated,
  Dimensions,
  Keyboard,
  Platform,
  StatusBar,
  TouchableWithoutFeedback,
} from 'react-native';

import {
  VFBackground,
  Icon,
  VFText,
  LeftIconErrorMessage,
} from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  LightThemeColors,
  getThemeImages,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import ToBi, { ToBiEmojis } from '@vfgroup-oneplatform/foundation/ToBi';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction, get as _get } from 'lodash';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';

import LoadingAnimation from '../../Components/LoadingAnimation';
import {
  Images,
  getThemeImages as getLoginThemeImages,
  getThemeColors as getLoginThemeColors,
} from '../../Themes';
import BiometryTypesEnum from '../../Utils/BiometryTypesEnum';
import LoginTestKeys from '../../Utils/LoginTestKeys';
import BiometricPopup, { requiresLegacyAuthentication } from '../BiometricPopup';

import styles from './AuthContainer.Styles';
import Labels from './Labels';

const { width: screenWidth } = Dimensions.get('screen');

function getTobiStyle(tobiSize, whiteBoxYPosition, whiteBoxLayout, customStyles, bubbleHeight) {
  const stylesArr = [styles.tobi];
  stylesArr.push({ marginTop: -(tobiSize / 2) });
  stylesArr.push(customStyles);
  return StyleSheet.flatten(stylesArr);
}

function getBubbleStyle(bubbleHeight, whiteBoxYPosition, whiteBoxLayout, tobiSize, loginColors) {
  const width = Platform.OS === 'web' ? 300 : screenWidth - (tobiSize + 30)
  const left = Platform.OS === 'web' ? whiteBoxLayout.left + (whiteBoxLayout.width - tobiSize - 300) : 16
  const stylesArr = [styles.bubbleView(loginColors)];
  stylesArr.push({
    width: width,
    top: whiteBoxYPosition - tobiSize / 2 - bubbleHeight,
    left: left
  });
  return StyleSheet.flatten(stylesArr);
}

function getScrollViewStyle(tobiSize) {
  const stylesArr = [styles.scrollViewStyle];
  stylesArr.push({ paddingVertical: tobiSize + 5, justifyContent: 'flex-start' })
  return StyleSheet.flatten(stylesArr);
}

const getTobiStyleMemoized = memoize(getTobiStyle);
const getScrollViewStyleMemoized = memoize(getScrollViewStyle);
const getBubbleStyleMemoized = memoize(getBubbleStyle);

class AuthContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bubbleHeight: 0,
      whiteBoxYPosition: 0,
      whiteBoxLayout: {},
      isBubbleVisible: false,
      isBiometricPopupVisible: false,
      biometryType: '',
      isBiometryDisabled: false,
    };
    this.tobiAnimation = new Animated.Value(0);
    this.bubbleViewAnimation = new Animated.Value(1);
    this.whiteBoxAnimation = new Animated.Value(0);
    this.timeOut = undefined;
  }

  componentDidMount() {
    const { withBiometricsLogin } = this.props;
    this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow);

    if (withBiometricsLogin) {
      this.triggerBiometricsPopup();
    }
  }

  componentDidUpdate(prevProps) {
    const { startAnimation, resetTimeOut } = this.props;
    if (prevProps.startAnimation !== startAnimation && startAnimation) {
      this.handleAnimation();
    } else if (resetTimeOut) {
      this.resetTimeOut();
    }
  }

  componentWillUnmount() {
    this.keyboardDidShowListener.remove();
  }

  onBubleLayout = ({ nativeEvent }) => {
    this.setState({ bubbleHeight: nativeEvent.layout.height });
  };

  onWhiteBoxLayout = ({ nativeEvent }) => {
    this.setState({
      whiteBoxYPosition: nativeEvent.layout.y,
      whiteBoxLayout: nativeEvent.layout
    })
  };

  onWhiteBoxContainerLayout = ({ nativeEvent }) => {
    this.whiteBoxContainerViewYPosition = nativeEvent.layout.y;
  };

  onBiometricsError = error => {
    const { onBiometricsError } = this.props;
    const { biometryType } = this.state;
    if (error.name === 'DeviceLocked' || error.name === 'DeviceLockedPermanent') {
      this.setState({
        isBiometricPopupVisible: false,
        biometryType: Object.values(BiometryTypesEnum).includes(error.biometric)
          ? error.biometric
          : biometryType,
        isBiometryDisabled: true,
      });
    } else {
      this.setState({ isBiometricPopupVisible: false });
    }
    onBiometricsError(error);
  };

  onBiometricsSuccess = () => {
    const { onBiometricsSuccess } = this.props;
    this.setState({ isBiometricPopupVisible: false });
    onBiometricsSuccess();
  };

  onBiometryTypeChange = biometryType => {
    this.setState({ biometryType, isBiometryDisabled: false });
  };

  _keyboardDidShow = () => {
    if (this.state.isBubbleVisible && this.whiteBoxAnimation._value === 0) {
      setTimeout(() => {
        this.handlewWhiteBoxAnimation(true);
      }, 500);
    }
  };

  handleAnimation = () => {
    const { tobiAnimation } = this;
    const { whiteBoxLayout } = this.state
    console.log("🚀 ~ file: AuthContainer.js:175 ~ AuthContainer ~ whiteBoxLayout:", whiteBoxLayout)
    let toValue
    if (Platform.OS === 'web') {
      if (whiteBoxLayout?.width) {
        toValue = whiteBoxLayout?.width / 2 - 80
      } else {
        toValue = screenWidth / 4 - 80

      }
    } else {
      toValue = screenWidth / 2 - 80
    }
    Animated.timing(tobiAnimation, {
      toValue: toValue,
      duration: 500,
      useNativeDriver: false,
    }).start(({ finished }) => {
      if (finished) {
        this.setState({ isBubbleVisible: true }, () => {
          setTimeout(() => {
            this.handlewWhiteBoxAnimation(true);
          }, 250);
        });

        this.timeOut = setTimeout(() => {
          this.backAnimation();
        }, 6000);
      }
    });
  };

  backAnimation = () => {
    this.setState({ isBubbleVisible: false }, () => {
      this.handlewWhiteBoxAnimation(false);
    });

    this.props.onEndAnimation();
    const { tobiAnimation } = this;
    Animated.timing(tobiAnimation, {
      toValue: 0,
      duration: 500,
      useNativeDriver: false,
    }).start(({ finished }) => {
      if (finished) {
        this.props.onEndAnimation();
      }
    });
  };

  handlewWhiteBoxAnimation = isBubbleVisible => {
    const emptySpace = this.whiteBoxContainerViewYPosition - (this.state.bubbleHeight + 100);
    if (emptySpace > 10 && isBubbleVisible) {
      return;
    }

    Animated.spring(this.whiteBoxAnimation, {
      toValue: isBubbleVisible ? 1 : 0,
      useNativeDriver: false,
    }).start();
  };

  resetTimeOut = () => {
    const { tobiAnimation, bubbleViewAnimation, whiteBoxLayout } = this;
    const toValue = Platform.OS === 'web' ? whiteBoxLayout?.width || screenWidth / 2 - 80 : screenWidth / 2 - 80
    clearTimeout(this.timeOut);
    tobiAnimation.setValue(toValue)
    bubbleViewAnimation.setValue(1);
    this.timeOut = setTimeout(() => {
      this.backAnimation();
    }, 6000);
  };

  triggerBiometricsPopup = () => {
    this.setState({ isBiometricPopupVisible: true });
  };

  renderErrorBox = (props, theme) => {
    if (_get(props, 'showErrorBox', false)) {
      return (
        <React.Fragment>
          <LeftIconErrorMessage
            imageAccessibilityLabel={LoginTestKeys.loginWarningIcon}
            errorMessageAccessibilityLabel={LoginTestKeys.loginErrorMsg1}
            testID={LoginTestKeys.errorBox}
            {...props}
          />
          <View style={styles.divider(theme)} />
        </React.Fragment>
      );
    }
  };

  render() {
    const {
      tobiTestId,
      children,
      childrenContainerAccessibilityLabel,
      tobiIconStyle,
      tobiSize,
      tobiEmoji,
      onEmojiEnd,
      bubbleText,
      tobiIconAccessibilityLabel,
      backBtn,
      backBtnPress,
      backBtnAccessibilityLabel,
      renderTobiLessIconView,
      renderFooter,
      errorProps,
      theme,
      withBiometricsLogin,
      biometricsConfig,
      biometricTextAccessibilityLabel,
      biometricTextTestId,
      renderTitle,
      isLoading,
      loadingText,
      insideBackBtn,
      isScrollableScreen,
      withCloseButton,
      onClosePress,
      subTitle,
      title,
      titleStyle,
    } = this.props;
    const themeName = theme ? theme.name : 'light';
    const loginColors = getLoginThemeColors(themeName);
    const {
      bubbleHeight,
      whiteBoxYPosition,
      whiteBoxLayout,
      isBubbleVisible,
      isBiometricPopupVisible,
      biometryType,
      isBiometryDisabled,
    } = this.state;

    const tobiStyle = getTobiStyleMemoized(tobiSize, whiteBoxYPosition, whiteBoxLayout, tobiIconStyle, bubbleHeight);
    const scrollViewStyle = getScrollViewStyleMemoized(tobiSize);
    const bubbleStyle = getBubbleStyleMemoized(
      bubbleHeight,
      whiteBoxYPosition,
      whiteBoxLayout,
      tobiSize,
      loginColors,
    );

    const tobiAnimationStyle = {
      transform: [{ translateX: this.tobiAnimation }],
    };
    const bubbleViewAnimationStyle = {
      opacity: this.bubbleViewAnimation,
    };

    const animatedWhiteBoxStyle = {
      marginTop: this.whiteBoxAnimation.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 90],
      }),
      alignItems: Platform.OS === 'web' ? 'center' : 'stretch'
    };

    const _biometricsConfig = biometricsConfig ? Platform.select(biometricsConfig) : {};

    const images = getThemeImages(theme.name);
    const loginImages = getLoginThemeImages(theme.name);

    return (
      <VFBackground type="tertiary" style={{
        ...Platform.select({
          web: {
            paddingHorizontal: 16,
            flexGrow: 1
          }
        })
      }}>
        <SafeAreaView style={styles.safeView}>
          <StatusBar
            barStyle="light-content"
            backgroundColor="transparent"
            hidden={false}
            translucent
          />
          {withCloseButton && (
            <View style={styles.closeButton}>
              <TouchableWithoutFeedback onPress={onClosePress}>
                <Icon name={loginImages.ic_close_white} type="image" size={30} />
              </TouchableWithoutFeedback>
            </View>
          )}
          <ScrollView
            keyboardShouldPersistTaps="handled"
            contentContainerStyle={scrollViewStyle}
            scrollEnabled={isScrollableScreen}
          >
            {backBtn && (
              <TouchableOpacity
                style={styles.btnBack}
                onPress={backBtnPress}
                accessibilityLabel={backBtnAccessibilityLabel}
                testID={backBtnAccessibilityLabel}
              >
                <Icon name={Images.ic_arrow_left_white} type="image" size={30} />
              </TouchableOpacity>
            )}

            <Animated.View
              style={animatedWhiteBoxStyle}
              onLayout={this.onWhiteBoxContainerLayout}
              testID={LoginTestKeys.codeVerifyAuthContainer}
            >
              {isBubbleVisible && (
                <Animated.View
                  style={[bubbleStyle, bubbleViewAnimationStyle]}
                  onLayout={this.onBubleLayout}
                >
                  <VFText
                    i18nKey={bubbleText}
                    style={styles.bubbleText(loginColors)}
                    accessibilityLabel={LoginTestKeys.loginSmsCodeMsg}
                  />
                </Animated.View>
              )}

              <View
                style={styles.whiteBox(loginColors)}
                accessibilityLabel={childrenContainerAccessibilityLabel}
                onLayout={this.onWhiteBoxLayout}
              >
                {insideBackBtn && (
                  <View style={styles.insideBackBtnContainer}>
                    <TouchableOpacity
                      style={styles.insideBackBtn}
                      onPress={backBtnPress}
                      accessibilityLabel={backBtnAccessibilityLabel}
                      testID={backBtnAccessibilityLabel}
                    >
                      <Icon name={images.ic_arrow_left} type="image" size={30} />
                    </TouchableOpacity>
                  </View>
                )}
                <Animated.View
                  style={[tobiStyle, tobiAnimationStyle]}
                  accessibilityLabel={LoginTestKeys.animationView}
                >
                  {_isFunction(renderTobiLessIconView) ? (
                    renderTobiLessIconView(theme)
                  ) : (
                    <ToBi
                      size={tobiSize}
                      emoji={tobiEmoji}
                      onEmojiFinish={onEmojiEnd}
                      accessibilityLabel={tobiIconAccessibilityLabel}
                      testID={tobiTestId}
                    />
                  )}
                </Animated.View>

                {isLoading ? (
                  <LoadingAnimation loadingText={loadingText} />
                ) : (
                  <View>
                    {_isFunction(renderTitle) ? (
                      renderTitle()
                    ) : (
                      <VFText
                        i18nKey={title}
                        style={[styles.titleStyle(theme), titleStyle]}
                        testID={LoginTestKeys.codeVerifyAuthContainerTitle}
                      />
                    )}
                    {subTitle ? <VFText i18nKey={subTitle} style={styles.subTitle(theme)} /> : null}
                    {this.renderErrorBox(errorProps, theme)}
                    {children}
                  </View>
                )}
                {withBiometricsLogin && !isLoading && (
                  <>
                    {biometryType != '' && !requiresLegacyAuthentication() && (
                      <TouchableOpacity
                        onPress={this.triggerBiometricsPopup}
                        style={styles.biometricTextView}
                        disabled={isBiometryDisabled}
                      >
                        <Icon
                          name={
                            biometryType === BiometryTypesEnum.Face_ID
                              ? Images.icFaceRecognitionRed
                              : Images.icBiometricAuthenticationRed
                          }
                          type="image"
                          size={25}
                          style={styles.biometricIcon(loginColors, isBiometryDisabled)}
                          accessibilityLabel={biometricTextAccessibilityLabel}
                          testID={biometricTextTestId}
                        />
                        <VFText
                          i18nKey={'biometric_login_use_biometry_type'}
                          placeHolders={[biometryType]}
                          style={styles.textLabel(loginColors, isBiometryDisabled)}
                        />
                      </TouchableOpacity>
                    )}
                    <BiometricPopup
                      showPopup={isBiometricPopupVisible}
                      {..._biometricsConfig}
                      onBiometricsSuccess={this.onBiometricsSuccess}
                      onBiometricsError={this.onBiometricsError}
                      onBiometryTypeChange={this.onBiometryTypeChange}
                    />
                  </>
                )}
                {_isFunction(renderFooter) && !isLoading ? renderFooter() : null}
              </View>
            </Animated.View>

            {!isLoading && <Labels {...this.props} />}
          </ScrollView>
        </SafeAreaView>
      </VFBackground>
    );
  }
}

AuthContainer.defaultProps = {
  theme: LightThemeColors,
  tobiSize: 87.4,
  backBtn: false,
  insideBackBtn: false,
  loadingText: '',
  backBtnPress: () => { },
  errorProps: {},
  withBiometricsLogin: false,
  biometricsConfig: {},
  onBiometricsSuccess: () => { },
  onBiometricsError: () => { },
  isScrollableScreen: true,
  title: 'login_title_text',
  tobiTestId: LoginTestKeys.Tobi,
};

AuthContainer.propTypes = {
  theme: PropTypes.object,
  tobiTestId: PropTypes.string,
  children: PropTypes.object,
  childrenContainerAccessibilityLabel: PropTypes.string,
  tobiSize: PropTypes.number,
  tobiEmoji: PropTypes.oneOfType([
    PropTypes.oneOf(Object.values(ToBiEmojis)),
    PropTypes.arrayOf(PropTypes.oneOf(Object.values(ToBiEmojis))),
  ]),
  onEmojiEnd: PropTypes.func,
  onEndAnimation: PropTypes.func,
  bubbleText: PropTypes.string,
  startAnimation: PropTypes.bool,
  resetTimeOut: PropTypes.bool,
  tobiIconStyle: ViewPropTypes.style,
  tobiIconAccessibilityLabel: PropTypes.string,
  backBtn: PropTypes.bool,
  backBtnPress: PropTypes.func,
  backBtnAccessibilityLabel: PropTypes.string,
  renderTobiLessIconView: PropTypes.func,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
  renderFooter: PropTypes.func,
  errorProps: PropTypes.shape({ ...LeftIconErrorMessage.propTypes }),
  renderTitle: PropTypes.func,
  withBiometricsLogin: PropTypes.bool,
  biometricsConfig: PropTypes.object,
  onBiometricsSuccess: PropTypes.func,
  onBiometricsError: PropTypes.func,
  biometricTextAccessibilityLabel: PropTypes.string,
  biometricTextTestId: PropTypes.string,
  insideBackBtn: PropTypes.bool,
  isScrollableScreen: PropTypes.bool,
  title: PropTypes.string,
  titleStyle: ViewPropTypes.style,
  subTitle: PropTypes.string,
  onClosePress: PropTypes.func,
  withCloseButton: PropTypes.bool,
};

export default withTheme(AuthContainer);
export { getTobiStyle, getBubbleStyle, getScrollViewStyle };
